import { useStageData } from "./useStageData";
import type { State } from "../domain";

const navigateProviderItem = <T extends State>(identifier?: T["identifier"], data?: T["data"]): void => {
    if (!identifier) return;

    const { setRequestData } = useStageData();
    // Trigger initial request
    // Note that TypeScript isn't able to combine the types anymore (it thinks the fields can be arbitrary); cast as T
    const requestData = { identifier, data: data ?? {} } as T;
    setRequestData(requestData);
};

export const useProviderItemHandler = (): {
    navigateProviderItem: <T extends State>(identifier?: T["identifier"], data?: T["data"]) => void;
} => ({ navigateProviderItem });
